

export default {
    clearUserInfo(state) {
        state.user_info = {}
    },
    setUserInfo(state, payload) {
        state.user_info = payload
    },
    setCurrentEvent(state, payload) {
        state.current_event = payload
    },
    setLanguage(state, payload) {
        state.lang = payload
    },
    setUsername(state, username) {
        state.user_info.user_name = username
    },
    setUserEmail(state, email) {
        state.user_info.login_email = email
    },
    setUserPhone(state, phone) {
        state.user_info.login_phone = phone
    },
    setUserAvatar(state, avatar) {
        state.user_info.user_avatar = avatar
    },
    setPingInterval(state, payload) {
        state.ping_interval = setInterval(() => {
            payload()
        }, 4000)
    },
    setCurrentSessionStatus(state, payload) {
        state.current_session_status = (payload == "True")
    },
    setCurrentSessionId(state, payload) {
        state.current_session_id = payload
    },
    clearPingInterval(state) {
        clearInterval(state.ping_interval)
    },
    add_ajax_spin(state) {
        state.ajax_spin_count++
    },
    sub_ajax_spin(state) {
        state.ajax_spin_count--
    },
    reset_ajax_spin(state) {
        state.ajax_spin_count = 0
    },
    saveEventMutation(state, payload){
      state.event = payload
    },
    set_current_role(state,payload){
      state.current_role = payload
    },
  set_current_event_id(state,payload){
    state.current_event_id = payload
  },
  saveEventMutation(state, payload){
    state.event = payload
  },
  changeIsRegister(state, payload){
    state.isRegister = payload
  },
  setAssistantTempSession(state,payload){
    state.assistant_temp_session=payload
  },
  clearAssistantTempSession(state){
    state.assistant_temp_session = null
  },
  setHelperRoles(state, payload){
    state.helper_roles = payload
  },
  hvuex(state, v) {
    var strObj = JSON.stringify(state.data);
    var obj = Object.assign(JSON.parse(strObj), v);
    state.data = obj;
    // console.log(obj, "hvuexMutations")
    hsetStore("hvuex",JSON.stringify(state.data));
  },
  setChannelList(state, channel_list){
    state.channel_list = channel_list
  },
  set_place_map(state,payload) {
    state.place_map = payload
  },
  set_current_identify(state,payload){
      state.current_identify = payload
  },
  get_identify_list(state,payload) {
    state.user_identify = []
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js